/**
 * Verbatim reviews left on the firm's Google Business Profile (Golden Beach),
 * checked against Michael's managed profile on 29 October 2026.
 *
 * These are displayed as attributed testimonials only. They are deliberately
 * NOT included in any Review/AggregateRating JSON-LD: Google's structured data
 * policy prohibits marking up reviews sourced from a third-party site.
 */
export type GoogleReview = {
  id: string;
  name: string;
  rating: number;
  body: string;
  postedAt: string;
};

export const GOOGLE_REVIEW_URL = "https://maps.google.com/?cid=17645464718929886346";

export const GOOGLE_REVIEWS: GoogleReview[] = [
  {
    id: "joshua-harriss",
    name: "Joshua Harriss",
    rating: 5,
    body: "Erin was fantastic to work with on a property purchase! Couldn’t recommend highly enough!",
    postedAt: "October 2026",
  },
  {
    id: "jeanne-carpenter",
    name: "Jeanne Carpenter",
    rating: 5,
    body: "Mike Klein has done our property settlements for the past 25 years. Excellent service and he is very knowledgeable. Great price point as well. Highly recommend using Mike",
    postedAt: "October 2026",
  },
  {
    id: "h-rubach",
    name: "H Rubach",
    rating: 5,
    body: "I’m so grateful for my experience with Coastside Law. Mike was incredibly supportive, approachable and genuinely cared about helping me through the process. I couldn’t recommend Mike and the team highly enough!",
    postedAt: "September 2026",
  },
  {
    id: "kimberley-hall",
    name: "Kimberley Hall",
    rating: 5,
    body: "Erin at Coastside Law was fantastic to work with when purchasing my first home. Her knowledge and guidance made the whole process so much easier, and she was always helpful and professional. I’m so grateful for her support and would highly recommend Erin to anyone buying a home!",
    postedAt: "September 2026",
  },
  {
    id: "mark-northfield",
    name: "Mark Northfield",
    rating: 5,
    body: "Hard to put into just how positive our experience was with Erin. Sound advice, reassurance and care were present from start to finish during what was a difficult process due to the other parties involved. We absolutely recommend this service 10/10",
    postedAt: "September 2026",
  },
  {
    id: "emma-lea",
    name: "Emma-Lea",
    rating: 5,
    body: "I cannot recommend Erin from Coast Side Law highly enough for her services during the settlement of our home. The entire process was seamless, transparent, and completely stress-free.",
    postedAt: "September 2026",
  },
  {
    id: "kirsty-bohn",
    name: "Kirsty Bohn",
    rating: 5,
    body: "We’ve used this lawyer for legal advice for our business and have been really happy with the experience. They’re approachable, thorough and explain things clearly, which makes it much easier to make confident decisions.\n\nCommunication has been excellent, and we’ve always felt that our questions were taken seriously. It’s reassuring to have someone we trust when a legal matter comes up. We’d happily recommend them to anyone looking for a knowledgeable and reliable lawyer.",
    postedAt: "September 2026",
  },
  {
    id: "meg-drewe",
    name: "Meg Drewe",
    rating: 5,
    body: "I can’t recommend Erin highly enough. Although things ultimately didn’t proceed, Erin went so far above and beyond to help me, and I’m genuinely so grateful for the time, care and knowledge she gave me. She was incredibly kind, patient and supportive, and always took the time to explain everything and answer my questions. Her guidance made such a difference during what was a stressful and uncertain time for me. It’s so lovely to come across a small local firm that genuinely cares about their clients and goes the extra mile to help. Erin is not only incredibly knowledgeable, but truly cares about the people she helps. I wouldn’t hesitate to recommend her to anyone.",
    postedAt: "September 2026",
  },
  {
    id: "lesley-bourke",
    name: "Lesley Bourke",
    rating: 5,
    body: "Erin was an absolute standout on the Sunshine Coast in assisting with our mutual sellers’ sale of their home. As a Solicitor, and we deal with many, her professionalism, attention to detail, knowledge, and clear communication were exceptional throughout the entire process. Erin was a pleasure to work alongside and made the legal side of the transaction seamless and straightforward for everyone involved. Her prompt communication and proactive approach were greatly appreciated, and it was clear that she genuinely cared about achieving the best outcome for our mutual clients. I would have no hesitation in recommending Erin to anyone looking for an outstanding Solicitor in the sale of their home. She is a true professional and an absolute asset to her clients.",
    postedAt: "September 2026",
  },
];
